import { Box } from "@mui/material"
import { shippingInvoiceColNm } from "branch/pages/ShippingProcess/constant"
import ComboBox from "components/ComboBox"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import JobDialog from "pages/Menu2/JobManagement/JobDialog"
import { useCallback, useContext, useMemo, useState } from "react"


const JobComboWithAdd = ({ dialogData, setDialogData, sx, required }) => {

  const { msData } = useContext(GlobalStateContext)
  const [dialogJobOpen, setDialogJobOpen] = useState(false)


  const jobCombo = useMemo(() => {
    let result = null
    if (dialogData.CusId) {
      result = msData.jobCombo.filter(item => item.refId === dialogData.CusId).map(item => item)
      result.push({ id: -1, label: "เพิ่มงานใหม่", group: "เพิ่มข้อมูล" })
    } else {
      result = []
    }
    return result
  }, [dialogData.CusId, msData.jobCombo])


  const handleSelectJobCombo = useCallback((id) => {
    setDialogData(o => {
      if (id === -1) {
        setDialogJobOpen(true)
      }
      return { ...o, JobId: id }
    })
  }, [setDialogData])

  const onDialogJobFinish = useCallback(async (id) => {
    setDialogData(o => ({ ...o, JobId: id }))
  }, [setDialogData])

  const jobDialogPropsMemo = useMemo(() => {
    return {
      state: { dialogOpen: dialogJobOpen, selectedId: 0, selectedCusId: dialogData.CusId },
      fn: {
        setDialogOpen: setDialogJobOpen,
        onFinish: onDialogJobFinish
      }
    }
  }, [dialogJobOpen, onDialogJobFinish, dialogData.CusId])
  return (
    <Box>

      <ComboBox sx={sx} options={jobCombo} label={shippingInvoiceColNm.JobSNm}
        selectedId={dialogData.JobId} required={required}
        setSelectedId={handleSelectJobCombo}
      />

      <JobDialog {...jobDialogPropsMemo} />
    </Box>
  )
}

export default JobComboWithAdd